import React from "react";

const AdvancementLine = ({advancement, target, advancementType="percentage" }) => {

    const returnAdvancementInPercentage = () => {
        const advancementValue = (advancement * 100) / target
        if (advancementValue >= 100){
            return 100
        } else {
            return advancementValue
        }
    }

    const getAdvancementColor = (advancement, target) => {
        if (advancement >= target){
            return '#52D783'
        } else {
            return '#FFB400'
        }
    }
    const progressBarStyle = {
        height: '100%',
        width: `${returnAdvancementInPercentage()}%`,
        textAlign: 'right',
        borderRadius: '0.4rem',
        background: getAdvancementColor(advancement, target)
    }

    return(
        <div id={"linear-container-okr"}>
            <p><span> {advancement} {advancementType === "percentage" ? "%" : ""}  </span></p>
            <div className="advancement-div">
                <p> {advancement} % </p>
                <div className="progress-container">
                    <div style={progressBarStyle}/>
                </div>
            </div>
        </div>
    )
}

export default AdvancementLine;